import React, { Fragment } from 'react';
import { Box, Divider, Grid, Typography } from '@dripcapital/dripui-v1';
import Modal from 'atoms/Modal';
import Spacer from 'atoms/Spacer';
import { DAJ_COLORS } from 'utils';
import Close from '@mui/icons-material/Close';

type Props = {
  openModal: boolean;
  setOpenModal: (x: boolean) => void;
  tax_form_information: object[];
};

const LinkModal: React.FC<Props> = ({
  openModal,
  setOpenModal,
  tax_form_information,
}: Props) => {
  return (
    <Modal
      isOpen={openModal}
      closeDialog={() => setOpenModal(false)}
      _sx={{ maxWidth: '800px', width: '800px' }}
    >
      <Box>
        <Close
          onClick={() => setOpenModal(false)}
          sx={{
            position: 'absolute',
            top: 16,
            right: 24,
            cursor: 'pointer',
            color: DAJ_COLORS.GREEN,
          }}
        />
        <Grid container>
          <Grid item xs={6}>
            <Typography variant="h4" fontWeight="bold">
              Company Type
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="h4" fontWeight="bold">
              Form Required
            </Typography>
          </Grid>
        </Grid>
        <Spacer verticalSpace={3} />
        <Grid container rowSpacing={1}>
          {tax_form_information.map((taxInfo: any, index) => {
            return (
              <Fragment key={index}>
                <Grid item xs={6}>
                  <Typography variant="body" fontWeight="bold">
                    {taxInfo.title}
                  </Typography>
                  <Typography variant="body-small">
                    {taxInfo.subtitle}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body" fontWeight="bold">
                    {taxInfo.form}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Divider
                    orientation="horizontal"
                    borderColor={DAJ_COLORS.SKY_BLUE_400}
                    weight={1}
                    _sx={{
                      display:
                        index === tax_form_information.length - 1
                          ? 'none'
                          : 'block',
                      marginBottom: 0,
                    }}
                    flexItem
                  />
                </Grid>
              </Fragment>
            );
          })}
        </Grid>
      </Box>
    </Modal>
  );
};
export default LinkModal;
